// - - - - - - - - - -
// crewScoreLabel — the crew cell's LTR line (#695, Leland 2026-10-15).
//
// "yr (25) 92%" (Leland 2026-10-16: one stat only, the year; the survey count in
// parentheses — was "4wk (2) 100% · yr 92%" on 10-15): the share of the crew's surveys over
// the last year answering 9–10 to "how likely are you to recommend" (crewScores in Convex,
// the same pass rates FAV 2.0 ranks on). No surveys in the year → null (no line).
// - - - - - - - - - -

const pct = (x) => `${Math.round(x * 100)}%`;

/** score = { w4: { ltr, n }, w52: { ltr, n } } from scheduler/crewScores:ltrForCrews. */
export function formatCrewLtrLine(score) {
  if (!score || !score.w52 || typeof score.w52.ltr !== "number" || !(score.w52.n > 0)) return null;
  return `yr (${score.w52.n}) ${pct(score.w52.ltr)}`;
}

/** The grid's crews as the sorted, de-duplicated payroll list the query takes (stable args). */
export function crewPayrollList(candidates, formatPayroll) {
  const out = new Set();
  for (const c of candidates || []) {
    const p = c && c.payrollNo != null ? formatPayroll(c.payrollNo) : "";
    if (p) out.add(p);
  }
  return [...out].sort();
}
